(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-pagination"] && !Shopify.designMode) return;
  try {
    class ResponsivePagination extends HTMLElement {
    connectedCallback() {
      this.navigation = this.querySelector('.collection-pagination');
      this.pages = this.querySelector('[data-pagination-pages]');
      this.parts = this.querySelector('[data-pagination-parts]');
      if (!this.navigation || !this.pages || !this.parts || this.observer) return;
      this.mobile = matchMedia('(max-width: 47.999rem)');
      this.navigation.dataset.responsive = '';
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.navigation);
      this.observer.observe(this.pages);
      this.mobile.addEventListener('change', this.update);
      document.fonts?.ready.then(() => { if (this.isConnected) this.update(); });
      this.update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.mobile?.removeEventListener('change', this.update);
      this.observer = null;
    }

    fits() {
      const children = [...this.navigation.children].filter(child => child.tagName !== 'TEMPLATE');
      const gap = parseFloat(getComputedStyle(this.navigation).columnGap) || 0;
      const width = children.reduce((total, child) => total + (child === this.pages ? child.scrollWidth : child.getBoundingClientRect().width), 0);
      return width + gap * (children.length - 1) <= this.navigation.clientWidth + 1;
    }

    renderPages(parts) {
      const children = [];
      for (const part of parts) {
        const previous = children.at(-1);
        if (previous && Number(part.dataset.page) - Number(previous.dataset.page) > 1) {
          const gap = document.createElement('span');
          gap.className = 'collection-pagination__ellipsis';
          gap.setAttribute('aria-hidden', 'true');
          gap.textContent = '…';
          children.push(gap);
        }
        children.push(part.cloneNode(true));
      }
      this.pages.replaceChildren(...children);
    }

    update = () => {
      if (!this.isConnected || !this.navigation.clientWidth) return;
      this.navigation.removeAttribute('data-wrap');
      const active = document.activeElement;
      const focusedPage = this.pages.contains(active) ? active.dataset.page : null;
      if (!this.mobile.matches) {
        this.pages.replaceChildren(this.parts.content.cloneNode(true));
        if (this.fits()) {
          this.restoreFocus(focusedPage);
          return;
        }
      }
      const numbered = [...this.parts.content.children].filter(part => part.dataset.page);
      const current = numbered.find(part => part.hasAttribute('aria-current'));
      if (!current) return;
      let selected = numbered.filter(part => part === numbered[0] || part === current || part === numbered.at(-1));
      this.renderPages(selected);
      if (!this.fits() && selected.length > 1) {
        const farthest = selected.filter(part => part !== current).sort((a, b) => Math.abs(Number(b.dataset.page) - Number(current.dataset.page)) - Math.abs(Number(a.dataset.page) - Number(current.dataset.page)))[0];
        selected = selected.filter(part => part !== farthest);
        this.renderPages(selected);
      }
      if (!this.fits()) this.renderPages([current]);
      if (!this.fits()) this.navigation.dataset.wrap = '';
      this.restoreFocus(focusedPage);
    };

    restoreFocus(page) {
      if (!page) return;
      const target = [...this.pages.children].find(part => part.dataset.page === page) || this.pages.querySelector('[aria-current]');
      if (target?.tagName !== 'A') target?.setAttribute('tabindex', '-1');
      target?.focus({ preventScroll: true });
    }
  }

  if (!customElements.get('responsive-pagination')) customElements.define('responsive-pagination', ResponsivePagination);
  } catch(e) { console.error(e); }
})();

})();
